import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=c5430aea&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./templateSelect.vue?vue&type=style&index=0&id=c5430aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5430aea",
  null
  
)

export default component.exports